module.exports = __webpack_public_path__ + "static/media/default-images.091510ae.png";